export const environment = {
  production: false,
  apiUrl: 'https://stgllf-mleapi.dhwaniris.in/api',
};